import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../translation/translation';
import ShippingLoader from './shipping_loader';
function ShippingQuote({openPostcode, httpRequestShippingFees}){
  if (true === httpRequestShippingFees.started
      && false === httpRequestShippingFees.success
      && false === httpRequestShippingFees.failed) {
      return (
          <ShippingLoader/>
         
      );
  } else if (true === httpRequestShippingFees.failed) {
      const {supportEmail, supportNumber, supportNumberLink} = TYROOLA.globals;
      return (
          <div className='shipping-fees'>
              <Translation
                  className="shipping-fees__loading-failed"
                  translationKey={'product-tile-shipping-quote-loading-failed'}
                  placeholder={{
                      SUPPORT_EMAIL: supportEmail,
                      SUPPORT_NUMBER: supportNumber,
                      SUPPORT_NUMBER_LINK: supportNumberLink
                  }}
                  tagName={'div'} />
          </div>
      );
  }

  return(
    <p onClick={openPostcode} className="shipping-fees__link">
      <Translation translationKey="product-tile-shipping-quote" />
    </p>
  );
}

ShippingQuote.propTypes = {
  openPostcode: PropTypes.func.isRequired,
  httpRequestShippingFees: PropTypes.shape( {
    started: PropTypes.bool.isRequired,
    success: PropTypes.bool.isRequired,
    failed: PropTypes.bool.isRequired,
  }),
};

ShippingQuote.defaultProps = {
    shippingPostcode: '',
};

export default ShippingQuote;